import { render, staticRenderFns } from "./RecipientListItem.vue?vue&type=template&id=c19d52a6&scoped=true"
import script from "./RecipientListItem.vue?vue&type=script&lang=js"
export * from "./RecipientListItem.vue?vue&type=script&lang=js"
import style0 from "./RecipientListItem.vue?vue&type=style&index=0&id=c19d52a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19d52a6",
  null
  
)

export default component.exports